export const iconFontAwesomeAlertCircleExclamation = (
	<i className="fa-solid fa-circle-exclamation"></i>
);
